export default __webpack_public_path__ + "static/media/EM1980.34I-43600_-26153_0.58eb98ef.jpg";